export default "__VITE_ASSET__CltVYQJz__"